<script lang="ts" setup>
import { useDisableReasons } from "@/composables/reactive/useDisableReasons";
import type { Anchor } from "vuetify/framework";
import type { DisabledRule } from "@/types/validation";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    rules: DisabledRule[];
    location?: Anchor;
  }>(),
  {
    location: "top",
  },
);

const rulesRef = computed(() => props.rules);

const { isDisabled, disabledReasons } = useDisableReasons(rulesRef);

const reasonList = computed(() => {
  return Array.isArray(disabledReasons.value) ? disabledReasons.value : [disabledReasons.value];
});
</script>

<template>
  <v-tooltip :disabled="!isDisabled" :location="props.location">
    <template #activator="{ props: tooltipProps }">
      <div v-bind="tooltipProps">
        <slot v-bind="{ disabled: isDisabled }"></slot>
      </div>
    </template>

    <template v-if="reasonList.length">
      <div>
        <span v-for="(reason, index) in reasonList" :key="index" class="white-space-pre-line">
          {{ reason }}<br v-if="index < reasonList.length - 1" />
        </span>
      </div>
    </template>
  </v-tooltip>
</template>
